// extracted by mini-css-extract-plugin
export default {"officeContainer":"offices_officeContainer__lGSLS","office":"offices_office__Pmek9","popUpModule":"offices_popUpModule__11yAc","popupButton":"offices_popupButton__imZZd"};